<template>
  <div id="app">
    <router-view>
    </router-view>
    <div class="loading-bg" v-show="loading"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      loading: false
    }
  },
  created () {
    //that.load.$emit('loading', false);     //加载动效的使用
    var that = this;
    this.load.$on('loading', function (data) {
      that.loading = !!data;
    });
  }
}
</script>

<style scoped lang="scss">
#app {
  font-family: Noto Sans SC,'宋体', Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: -webkit-linear-gradient(#009cd5, #0b318f); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#009cd5, #0b318f); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#009cd5, #0b318f); /* Firefox 3.6 - 15 */
  background: linear-gradient(#009cd5, #0b318f); /* 标准的语法 */
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding-left: 0px;
  min-width: 1220px;
}

.loading-bg {
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-size: 300px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("./assets/loadingIcon.gif");
}


// 分页标样式表

/deep/
.el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    color: #303133;
    font-weight: 700;
    text-align: right;
}
/deep/
.el-pagination button:disabled {
    color: #C0C4CC;
    background-color: rgba(255,255,255,0);
    cursor: not-allowed;
}

/deep/
.el-pagination button {
    color: #C0C4CC;
    background-color: rgba(255,255,255,0);
    cursor: not-allowed;
}

/deep/
.el-pagination .btn-next, .el-pagination .btn-prev {
    background: rgba(255,255,255,0);
    background-size: 16px;
    cursor: pointer;
    margin: 0;
    color: #C0C4CC;
}

/deep/
.el-pager li {
    background: rgba(255,255,255,0);
    color:#ffffff;
    font-size:18px
}

/deep/
.el-pager li.active {
    color: #E71489;
    cursor: default;
    font-size:20px
}

</style>



// WEBPACK FOOTER //
// src/App.vue